import { useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

const values = [
  { icon: "ri-honor-of-kings-fill", title: "公正", desc: "榜单数据透明,综合人气、评分与口碑,绝不掺杂水分。" },
  { icon: "ri-heart-fill", title: "热爱", desc: "每个编辑都是深度韩漫读者,用热爱打磨每一次推荐。" },
  { icon: "ri-seedling-fill", title: "多元", desc: "从甜宠到悬疑,尊重每一种口味,让好作品不被埋没。" },
  { icon: "ri-community-fill", title: "开放", desc: "欢迎读者投稿与反馈,共同建设更懂你的免费韩漫社区。" },
];

const testimonials = [
  { name: "小鹿不迷路", role: "甜宠爱好者", text: "在这里找到了好多宝藏甜宠,排行榜更新超快,再也不怕剧荒了!" },
  { name: "悬疑控阿黎", role: "悬疑读者", text: "分类很清晰,悬疑榜上的作品质量都超高,编辑品味真的在线。" },
  { name: "熬夜追更人", role: "热血读者", text: "免费韩漫高分榜单太实用了,按评分一刷一个准,闭眼入不踩雷。" },
];

export default function About() {
  useEffect(() => { document.title = "关于我们 · 漫糖韩漫"; }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      <section className="bg-foreground-950">
        <div className="mx-auto max-w-7xl px-4 pb-12 pt-24 md:px-6 md:pt-28">
          <nav aria-label="面包屑" className="flex items-center gap-1.5 text-xs text-background-400">
            <Link to="/" className="hover:text-background-100">首页</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-background-200">关于我们</span>
          </nav>
          <div className="mt-5 text-center">
            <span className="inline-flex items-center gap-1.5 rounded-full border border-background-50/20 bg-background-50/10 px-4 py-1.5 text-sm text-background-200">
              <i className="ri-flag-2-fill text-primary-400"></i>
              关于漫糖韩漫
            </span>
            <h1 className="mx-auto mt-5 max-w-3xl font-heading text-3xl leading-tight text-background-50 md:text-5xl">
              让每一个爱看韩漫的人,
              <br className="hidden md:block" />
              都能轻松找到对味的作品
            </h1>
            <p className="mx-auto mt-4 max-w-2xl text-sm leading-relaxed text-background-300 md:text-base">
              漫糖韩漫是一个专注免费韩漫推荐的榜单与分类平台。我们用数据与热爱,
              把茫茫韩漫海洋里最值得看的作品整理成清晰的人气排行榜与高分榜单。
            </p>
          </div>
        </div>
      </section>

      {/* 品牌介绍 */}
      <section className="mx-auto max-w-7xl px-4 py-14 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:items-center">
          <div className="overflow-hidden rounded-3xl">
            <img
              src="https://readdy.ai/api/search-image?query=Colorful%20illustration%20of%20a%20diverse%20team%20of%20young%20manga%20enthusiasts%20reading%20webtoons%20on%20devices%20around%20a%20table%2C%20warm%20coral%20teal%20and%20gold%20palette%2C%20cozy%20creative%20atmosphere%2C%20stylish%20flat%20illustration&width=1200&height=800&seq=hanman-about-team&orientation=landscape"
              alt="漫糖韩漫推荐团队工作场景插画"
              className="w-full object-cover"
            />
          </div>
          <div>
            <span className="flex items-center gap-1.5 text-sm font-medium text-primary-600">
              <i className="ri-store-2-fill"></i>
              关于本站
            </span>
            <h2 className="mt-2 font-heading text-2xl text-foreground-950 md:text-3xl">我们为什么做这个站</h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              喜欢看韩漫的人越来越多,但作品浩如烟海,好作品很容易被淹没。漫糖韩漫应运而生:
              我们按题材整理分类,实时更新人气推荐,编辑精选口碑佳作,把「该看什么」这件费时的事,
              变成一次轻松的选择。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              无论是甜宠、奇幻、剧情还是悬疑,我们只做一件事——用真实的数据与认真的推荐,
              帮你在这份免费韩漫高分榜单里,快速找到对味的那一部。
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link to="/ranking" className="flex items-center gap-2 rounded-full bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600">
                <i className="ri-trophy-fill"></i>
                查看排行榜
              </Link>
              <Link to="/category" className="flex items-center gap-2 rounded-full border border-background-300 px-6 py-3 text-sm font-medium text-foreground-800 whitespace-nowrap transition-colors hover:bg-background-100">
                浏览分类
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* 核心价值观 */}
      <section className="bg-background-100">
        <div className="mx-auto max-w-7xl px-4 py-14 md:px-6">
          <div className="text-center">
            <span className="flex items-center justify-center gap-1.5 text-sm font-medium text-primary-600">
              <i className="ri-compass-3-fill"></i>
              我们的坚持
            </span>
            <h2 className="mt-2 font-heading text-2xl text-foreground-950 md:text-4xl">内容原则与价值观</h2>
          </div>
          <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {values.map((v) => (
              <div key={v.title} className="rounded-3xl border border-background-200/70 bg-background-50 p-6">
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary-100 text-primary-700">
                  <i className={`${v.icon} text-xl`}></i>
                </span>
                <h3 className="mt-4 text-lg font-bold text-foreground-950">{v.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 读者口碑 */}
      <section className="mx-auto max-w-7xl px-4 py-14 md:px-6">
        <div className="text-center">
          <span className="flex items-center justify-center gap-1.5 text-sm font-medium text-secondary-600">
            <i className="ri-double-quotes-l"></i>
            读者口碑
          </span>
          <h2 className="mt-2 font-heading text-2xl text-foreground-950 md:text-4xl">他们说</h2>
        </div>
        <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-3">
          {testimonials.map((t) => (
            <figure key={t.name} className="rounded-3xl border border-background-200/70 bg-background-100 p-6">
              <div className="flex gap-1 text-accent-500">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-sm"></i>
                ))}
              </div>
              <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700">"{t.text}"</blockquote>
              <figcaption className="mt-4 flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-secondary-500 text-background-50">
                  {t.name[0]}
                </span>
                <div>
                  <p className="text-sm font-bold text-foreground-950">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.role}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </section>

      {/* 联系方式 */}
      <section className="mx-auto max-w-4xl px-4 pb-16 md:px-6">
        <div className="rounded-3xl border border-background-200/70 bg-background-100 p-8 text-center md:p-10">
          <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-accent-500 text-background-50 mx-auto">
            <i className="ri-mail-send-fill text-xl"></i>
          </span>
          <h2 className="mt-4 font-heading text-2xl text-foreground-950">联系我们</h2>
          <p className="mx-auto mt-2 max-w-md text-sm leading-relaxed text-foreground-600">
            有喜欢的作品想推荐?有意见想反馈?欢迎随时和我们聊聊,你的每一条建议都很重要。
          </p>
          <div className="mt-5 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <span className="flex items-center gap-2 rounded-full bg-background-50 px-5 py-2.5 text-sm text-foreground-700">
              <i className="ri-mail-line text-primary-600"></i>
              hello@mantang.hanman
            </span>
            <span className="flex items-center gap-2 rounded-full bg-background-50 px-5 py-2.5 text-sm text-foreground-700">
              <i className="ri-wechat-line text-secondary-600"></i>
              微信公众号 · 漫糖韩漫
            </span>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}